import { ErrorActionType } from '../action-types/errorTypes';
import { ErrorActions } from '../actions/errorTypes';

interface ErrorState {
  errorInfoText: string;
  validatePaymentError: boolean;
  validatePaymentErrorMessage: { code: number; message: string };
  errorType: string;
  trackingPageName: string;
  validation: ValidationType;
}

const initialState: ErrorState = {
  errorInfoText: '',
  validatePaymentError: false,
  validatePaymentErrorMessage: { code: 1000, message: '' },
  errorType: '',
  trackingPageName: '',
  validation: 'INACTIVE',
};

const errorReducer = (state: ErrorState = initialState, action: ErrorActions) => {
  switch (action.type) {
    case ErrorActionType.SET_VALIDATE_PAYMENT_ERROR:
      return {
        ...state,
        validatePaymentError: action.payload,
      };
    case ErrorActionType.SET_VALIDATE_PAYMENT_ERROR_MESSAGE:
      return {
        ...state,
        validatePaymentErrorMessage: action.payload,
      };
    case ErrorActionType.SET_ERROR_INFO_TEXT:
      return {
        ...state,
        errorInfoText: action.payload,
      };
    case ErrorActionType.SET_ERROR_TYPE:
      return {
        ...state,
        errorType: action.payload,
      };
    case ErrorActionType.SET_TRACKING_PAGE_NAME:
      return {
        ...state,
        trackingPageName: action.payload,
      };
    case ErrorActionType.SET_VALIDATION: {
      if (state.validation === 'NOT_VALID' && action.payload === 'IS_VALID') {
        return state;
      }
      return {
        ...state,
        validation: action.payload,
      };
    }
    default:
      return state;
  }
};

export default errorReducer;
